export const CAPI_EVENT_ENDPOINT = "/event";
export const CAPI_INTERNAL_EVENTS_ENDPOINT = "/internal/events";
